import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ft-user-image-renderer',
    templateUrl: './user-image-renderer.component.html',
    styleUrls: ['./user-image-renderer.component.scss'],
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserImageRendererComponent implements OnChanges {
    @Input() value: any;
    @Input() row: any;
    user: any;
    userInitials: string;

    ngOnChanges(): void {
        this.deriveView();
    }

    private deriveView(): void {
        this.user = this.value;
        this.setUserInitials();
    }

    setUserInitials() {
        this.userInitials = this.user ? this.user.name.split(' ').reduce((prev, string) => {
            return prev + string[0];
        }, '') : '';
    }
}
